import { createContext, useContext, PropsWithChildren } from "react";
import { GameVisuals } from "../gql/graphql";

export interface GameVisualsProviderProps extends PropsWithChildren {
  gameVisuals: GameVisuals;
}

export const GameVisualsContext = createContext<GameVisuals | undefined>(undefined);

export const GameVisualsProvider = ({ children, gameVisuals }: GameVisualsProviderProps) => {
  return <GameVisualsContext.Provider value={gameVisuals}>{children}</GameVisualsContext.Provider>;
};

export const useGameVisuals = () => {
  return useContext(GameVisualsContext);
};
